(function () {
  'use strict';

  // Cache local : Map<productId(string), {limit: number, qty: number}>
  const state = new Map();

  function msgs() {
    return window.pkCartLimitMessages || {
      reached: 'Limite atteinte : maximum {{ count }} de ce produit par panier.',
      badge: 'Max {{ count }} par panier',
      at_limit: 'Limite atteinte',
    };
  }

  // ── Toast ────────────────────────────────────────────────────────────────────
  let toastEl = null;
  let toastTimer = null;

  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pk-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('pk-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('pk-toast--visible'), 4000);
  }

  // ── Hydration DOM ────────────────────────────────────────────────────────────
  function hydrateElements(cartData) {
    // Construire map productId -> qty totale dans le panier
    const cartQty = new Map();
    (cartData.items || []).forEach(item => {
      const pid = String(item.product_id);
      cartQty.set(pid, (cartQty.get(pid) || 0) + item.quantity);
    });

    document.querySelectorAll('[data-pk-product-id]').forEach(el => {
      const pid = String(el.dataset.pkProductId);
      const limit = parseInt(el.dataset.pkLimitCart, 10);
      const qty = cartQty.get(pid) || 0;

      el.dataset.pkInCart = qty;
      state.set(pid, { limit, qty });

      // Désactiver boutons si déjà à la limite au chargement
      if (limit > 0 && qty >= limit) {
        disableSubmitForProduct(el);
      }
    });
  }

  function disableSubmitForProduct(anchorEl) {
    // Cherche le bouton submit le plus proche dans le form parent
    const form = anchorEl.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const btn = form.querySelector('[type="submit"][name="add"]');
    if (!btn) return;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('disabled', '');
    const span = btn.querySelector('span:first-child');
    if (span) span.textContent = msgs().at_limit;
  }

  // ── Fetch cart initial ────────────────────────────────────────────────────────
  function refreshState() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(hydrateElements);
  }

  // ── Submit capture (préempte ProductForm Dawn) ────────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    const productFormEl = form.closest('product-form');
    if (!productFormEl) return;

    const limitEl = productFormEl.querySelector('[data-pk-product-id]')
      || productFormEl;

    const limit = parseInt(limitEl.dataset.pkLimitCart, 10);
    if (!limit || limit <= 0) return;

    const pid = String(limitEl.dataset.pkProductId);
    const inCart = parseInt(limitEl.dataset.pkInCart, 10) || 0;
    const qtyInput = form.querySelector('[name="quantity"]');
    const adding = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (inCart + adding > limit) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const msg = msgs().reached.replace('{{ count }}', limit);
      showToast(msg);
      disableSubmitForProduct(limitEl);
    }
  }, true);

  // ── Fetch wrap (filet de sécurité contre ajouts programmatiques) ──────────────
  const _nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input.url || '');
    const isCartAdd = url.includes('/cart/add');

    if (!isCartAdd) return _nativeFetch.apply(this, arguments);

    // Extraire id/quantity du body pour résoudre vers product_id
    let variantId = null;
    let adding = 1;

    if (init && init.body) {
      let body = init.body;
      if (typeof body === 'string') {
        try { body = JSON.parse(body); } catch (_) {}
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        variantId = body.get('id');
        adding = parseInt(body.get('quantity'), 10) || 1;
      } else if (body && typeof body === 'object') {
        variantId = body.id;
        adding = parseInt(body.quantity, 10) || 1;
      }
    }

    if (!variantId) return _nativeFetch.apply(this, arguments);

    // Chercher le product_id correspondant dans le DOM
    const variantEl = document.querySelector(`[name="id"][value="${variantId}"]`);
    const productFormEl = variantEl && variantEl.closest('product-form');
    const limitEl = productFormEl && (
      productFormEl.querySelector('[data-pk-product-id]') || productFormEl
    );

    const limit = limitEl && parseInt(limitEl.dataset.pkLimitCart, 10);
    if (!limit || limit <= 0) return _nativeFetch.apply(this, arguments);

    const pid = String(limitEl.dataset.pkProductId);
    const cached = state.get(pid);
    const inCart = cached ? cached.qty : (parseInt(limitEl.dataset.pkInCart, 10) || 0);

    if (inCart + adding > limit) {
      showToast(msgs().reached.replace('{{ count }}', limit));
      return Promise.reject(new Error('pk-cart-limit: limite panier atteinte'));
    }

    return _nativeFetch.apply(this, arguments);
  };

  // ── Cart drawer +/- (capture phase, avant CartItems.onChange) ────────────────
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input.matches('.quantity__input[data-pk-product-id]')) return;

    const limit = parseInt(input.dataset.pkLimitCart, 10);
    if (!limit || limit <= 0) return;

    const newVal = parseInt(input.value, 10) || 0;
    if (newVal > limit) {
      input.value = limit;
      showToast(msgs().reached.replace('{{ count }}', limit));
    }
  }, true);

  // ── Sync PubSub après cart update ────────────────────────────────────────────
  // PUB_SUB_EVENTS et subscribe viennent de constants.js / pubsub.js (globals Dawn)
  document.addEventListener('DOMContentLoaded', function () {
    refreshState();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshState);
    }
  });
})();
